const edadesProfesionales = [
  { id: "MENOS30", text: "Menores de 30 años" },
  { id: "3045", text: "30 a 45 años" },
  { id: "MAS45", text: "Más de 45 años" },
];

export const edadesProfesionalesMap = edadesProfesionales.reduce(
  (prev, value) => {
    return {
      ...prev,
      [value.id]: value.text,
    };
  },
  {}
);

export { edadesProfesionales };
